import CollapsibleSection from "components/DetailPage/CollapsibleSection";
import React from "react";
import MergeSubTopic from "./MegeSubTopic";
import Tag from "components/Tag/Tag";

interface Props {
  mergeTopic: server.dto.AvailableMergeFieldTopic
  selectedCount: number
  selectedMergeFieldsSet: Set<string>
  onMergefieldChanged: (mergefieldId: string, checked: boolean) => void
}

const MergeTopic = (props: Props) => {
  return <CollapsibleSection
    title={<div className="flex gap">
      {props.mergeTopic.label}
      {props.selectedCount > 0 && <Tag color="blue" label={`${props.selectedCount}`} />}
    </div>}
    uniqueRowId={props.mergeTopic.label}
    collapsible="startClosed"
  >
    <div className="flex-column gap">
      {props.mergeTopic.subTopics.map((subTopic, id) => (
        <MergeSubTopic
          key={id}
          subtopic={subTopic}
          selectedMergeFieldsSet={props.selectedMergeFieldsSet}
          onMergefieldChanged={props.onMergefieldChanged}
        />
      ))}
    </div>
  </CollapsibleSection>
};

export default MergeTopic;